import React from 'react';
import { column } from '../styles';
import C from '../images/Projects/Misc/Class.m4v';
import { Player } from 'video-react';
import "../../../node_modules/video-react/dist/video-react.css";

class Classes extends React.Component {

    render() {
        return (
            <div style={column}>
                <div style={{display: "flex", justifyContent: "center", alignItems: "start", flexDirection: "row", width: '77%'}}>
                    <div style={{ width: '30%', height:'100%', fontWeight:'bold' }}>
                        <h2 style={{ marginBottom: "0" }}>Relative Coursework</h2>
                        <hr></hr>
                        <h3>Currently Enrolled In:</h3>
                        <ul>
                            <li>Fluids</li>
                            <li>Robotics</li>
                            <li>Industrial Controls</li>
                        </ul>

                        <h3>Completed:</h3>
                        <ul>
                            <li>AutoCAD</li>
                            <li>SolidWorks</li>
                            <li>MatLab</li>
                            <li>Strengths of Materials</li>
                            <li>Dynamics</li>
                            <li>
                                Metallic Processes
                                <ul>
                                    <li>Lathe Work</li>
                                    <li>Sheet Metal</li>
                                    <li>Welding</li>
                                    <li>Casting</li>
                                </ul>
                            </li>
                            <li>SQL (currently enrolled via Udemy)</li>
                            <li>
                                Microsoft Office
                                <ul>
                                    <li>Excel</li>
                                    <li>PowerPoint</li>
                                    <li>Word</li>
                                    <li>etc.</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div style={{width:'3.3%'}}></div>
                    <div style={{ width: '30%', height:'100%', fontWeight:'bold' }}>
                        <h2 style={{ marginBottom: "0" }}>Knowledge and Experience</h2>
                        <hr></hr>
                        <ul>
                            <li>AutoCAD</li>
                            <li>SolidWorks (hours of my own time in projects at home)</li>
                            <li>Microsoft Office (Excel, Word, etc.)</li>
                            <li>Physics (completed Minor at EWU)</li>
                            <li>Strengths, Dynamics</li>
                            <li>Cura 3D printing software</li>
                            <li>
                                Mathematics
                                <ul>
                                    <li>Calculus</li>
                                    <li>Trigonometry</li>
                                    <li>Geometry</li>
                                    <li>Algebra</li>
                                    <li>etc.</li>
                                </ul>
                            </li>
                            <li>Creative, Out of the Box Thinking</li>
                            <li>Quickly Adapting to New Software and Technologies</li>
                        </ul>
                    </div>
                    <div style={{width:'3.3%'}}></div>
                    <div style={{width:'30%'}}>
                            <div style={{width:'70%'}}>
                                <Player
                                    style={{width:'80%'}}
                                    playsInline
                                    poster="/assets/poster.png"
                                    src={C}
                                />
                                <p style={{ margin: '0px', marginTop: '10px'}}>A brief video of a classmate pouring aluminum for our casts in Metallic Processes class. All of us made a cast, but only myself and a couple others actually had the chance to pour the aluminum.</p>
                            </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Classes